export default __webpack_public_path__ + "static/media/nl-flag.6a354ec3.svg";